/**
 * AchievementDefinitions - Badge registry for curriculum-wide achievements.
 *
 * Extended from bumblebee BadgeDefinitions with curriculum-level badges.
 *
 * @see GitHub Issue #852
 */

const BADGES = [
    // --- Progression badges ---
    {
        id: 'first-activity',
        name: 'First Steps',
        description: 'Completed your first activity!',
        category: 'progression',
        icon: 'badge-first-steps',
        condition: {type: 'activity-complete', activityId: 'make-the-cat-dance'}
    },
    {
        id: 'course-complete-first-steps',
        name: 'Code Explorer',
        description: 'Completed the First Steps in Code course!',
        category: 'progression',
        icon: 'badge-explorer',
        condition: {type: 'course-complete', courseId: 'first-steps'}
    },

    // --- Skill badges ---
    {
        id: 'perfect-score',
        name: 'Star Collector',
        description: 'Earned 3 stars on an activity!',
        category: 'skill',
        icon: 'badge-stars',
        condition: {type: 'stars-earned', minStars: 3}
    },
    {
        id: 'no-hints-used',
        name: 'Independent Thinker',
        description: 'Completed an activity without any hints!',
        category: 'skill',
        icon: 'badge-independent',
        condition: {type: 'no-hints'}
    },
    {
        id: 'three-star-streak',
        name: 'On a Roll',
        description: 'Earned 3 stars three times in a row!',
        category: 'skill',
        icon: 'badge-streak',
        condition: {type: 'streak', minStreak: 3}
    },

    // --- Effort badges ---
    {
        id: 'determined-solver',
        name: 'Never Give Up',
        description: 'Kept trying until you got it! (5+ attempts)',
        category: 'effort',
        icon: 'badge-determined',
        condition: {type: 'attempts-threshold', minAttempts: 5}
    },
    {
        id: 'creative-solution',
        name: 'Creative Coder',
        description: 'Found your own unique way to solve it!',
        category: 'effort',
        icon: 'badge-creative',
        condition: {type: 'creative-solution'}
    },

    // --- Milestone badges ---
    {
        id: 'ten-stars',
        name: 'Rising Star',
        description: 'Earned 10 total stars!',
        category: 'milestone',
        icon: 'badge-rising-star',
        condition: {type: 'total-stars', minTotalStars: 10}
    },
    {
        id: 'thirty-stars',
        name: 'Superstar',
        description: 'Earned 30 total stars!',
        category: 'milestone',
        icon: 'badge-superstar',
        condition: {type: 'total-stars', minTotalStars: 30}
    }
];

export default class AchievementDefinitions {
    /**
     * Get all badge definitions.
     * @returns {Array}
     */
    static getAll () {
        return BADGES;
    }

    /**
     * Get a badge by ID.
     * @param {string} id
     * @returns {object|undefined}
     */
    static get (id) {
        return BADGES.find(b => b.id === id);
    }

    /**
     * Get badges by category.
     * @param {string} category
     * @returns {Array}
     */
    static byCategory (category) {
        return BADGES.filter(b => b.category === category);
    }

    /**
     * Get all category names.
     * @returns {string[]}
     */
    static categories () {
        return [...new Set(BADGES.map(b => b.category))];
    }
}
